import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';

/* State */
import { AuthState } from '@core/store/auth/auth.state';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard  {
	constructor(private router: Router, private store: Store) {}

	canActivate(): boolean | UrlTree {
		const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);

		return isAuthenticated === null || !isAuthenticated ? this.router.parseUrl('login') : true;
	}

	canLoad(): boolean | UrlTree {
		const isAuthenticated = this.store.selectSnapshot(AuthState.isAuthenticated);

		return isAuthenticated === null || !isAuthenticated ? this.router.parseUrl('login') : true;
	}
}
